/**
 * @prettier
 */

import { usePosUserLockScreenActions } from 'src/services/pos/PosUserLockScreen/posUserLockScreenStore';

export function useSetHasClockedIn(): (tryingClockIn: boolean) => void {
    return usePosUserLockScreenActions((actions) => actions.setHasClockedIn);
}
